




import { defineComponent } from "@vue/composition-api";
import Alert from "../../components/misc/alert.vue";

export default defineComponent({
    name: "sidebarReservationsEmpty",
    components: { Alert },
    props: {},
    setup(props, ctx) {},
});
